// Frontend served locally on totem (Windows) or from the cloud —
// always connects to the remote API. Offline resilience is handled
// by the localStorage sync queue in offlineSync.ts.
const HOST = 'https://roleta-api.quantictechnology.com.br';
const PORT = '';

// Remote API URL (always points to the cloud server, used for sync)
export const REMOTE_API = 'https://roleta-api.quantictechnology.com.br';

/** Build base URL */
export const API_BASE = HOST;

const config = {
  HOST,
  PORT,
};

export default config;